// A runtime can own the final commit of its current pointer gesture. Keep the
// claim outside the mutable drag payload, scoped to the exact host context.
const claims = new WeakMap();

export function claimPointerCommit(drag, owner, project, sheetId) {
  if (!drag?.active || !project || !owner || (drag.systemId || drag.owner) !== owner) return false;
  claims.set(drag, { owner, project, sheetId });
  return true;
}

export function hasPointerCommitClaim(drag, owner, project, sheetId) {
  const claim = drag && claims.get(drag);
  return Boolean(claim && claim.owner === owner && claim.project === project && claim.sheetId === sheetId);
}
